/* Newsletter-Anmeldung auf /pages/newsletter
 *
 * Schickt die Adresse an den Nerd Mailer und zeigt danach den Hinweis auf die
 * Bestätigungsmail. Angemeldet ist niemand allein durch dieses Formular —
 * erst der Klick im Bestätigungslink zählt (Double-Opt-In).
 *
 *   POST /apps/newsletter/api/subscribe   {"email": "...", "source": "page"}
 *
 * Der Pfad läuft über den Shopify App Proxy: same-origin, von Shopify
 * HMAC-signiert, kein Schlüssel im Frontend. Siehe [app_proxy] in der
 * shopify.app.toml des Nerd Mailer.
 *
 * Zur Fehlerbehandlung: Der Server antwortet absichtlich gleich, egal ob die
 * Adresse neu, gesperrt oder schon angemeldet ist — sonst wäre das Formular
 * eine Auskunft darüber, wer Kunde ist. Wir zeigen deshalb bei jeder
 * erfolgreichen Antwort denselben Hinweis.
 */
(function () {
  'use strict';

  const root = document.querySelector('.nl-anmeldung');
  if (!root) return;

  const strings = JSON.parse(decodeHtmlEntities(root.dataset.strings || '{}'));
  const form = root.querySelector('[data-form="anmeldung"]');
  const input = form?.querySelector('input[name="email"]');
  const button = form?.querySelector('[data-action="submit"]');
  const fehlerEl = form?.querySelector('[data-error="form"]');
  if (!form || !input || !button) return;

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    absenden();
  });

  async function absenden() {
    setFehler('');

    const email = (input.value || '').trim();
    // Nur eine grobe Vorprüfung, damit offensichtliche Tippfehler nicht erst
    // eine Anfrage kosten. Die verbindliche Prüfung macht der Server.
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setFehler(strings.err_email || 'Bitte gib eine gültige E-Mail-Adresse ein.');
      input.focus();
      return;
    }

    setBusy(true);
    try {
      const res = await fetch('/apps/newsletter/api/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          email: email,
          // Erster Besuch dieses Browsers, siehe erstkontakt.js
          erstkontakt: window.gdErstkontakt ? window.gdErstkontakt() : null,
          source: 'page',
          // Sprache der Seite: bestimmt Sprache von Bestätigungsmail und -seite.
          // Der App Proxy schickt kein locale mit, siehe proxy.newsletter.api.subscribe.tsx.
          sprache: root.dataset.sprache || '',
          // Nachweis, dass hier ein Mensch sitzt. Siehe turnstile-gate.js.
          turnstileToken: await (window.gdTurnstile?.holeToken?.() ?? Promise.resolve(null)),
        }),
      });
      const data = await res.json().catch(() => null);

      if (res.ok && data && data.ok) {
        zeigeZustand('SUCCESS');
        return;
      }
      if (data && data.error === 'invalid_email') {
        setFehler(strings.err_email || 'Bitte gib eine gültige E-Mail-Adresse ein.');
        return;
      }
      setFehler(strings.err_allgemein || 'Das hat gerade nicht geklappt.');
    } catch (err) {
      console.error('[newsletter] Anmeldung fehlgeschlagen', err);
      setFehler(strings.err_allgemein || 'Das hat gerade nicht geklappt.');
    } finally {
      setBusy(false);
    }
  }

  function zeigeZustand(name) {
    root.querySelectorAll('.nl-state').forEach((el) => {
      el.hidden = el.dataset.state !== name;
    });
  }

  function setFehler(text) {
    if (fehlerEl) fehlerEl.textContent = text;
  }

  function setBusy(busy) {
    button.disabled = busy;
    button.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  /* Die Texte kommen über ein data-Attribut aus Liquid und sind dort
     HTML-escaped. */
  function decodeHtmlEntities(str) {
    const el = document.createElement('textarea');
    el.innerHTML = str;
    return el.value;
  }
})();
